import { generic_post_network_request } from '../axiosClient/axiosClient';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface Announce_Payload_Type {
  user_ids: number[];
  role_ids?: number[];
  file_name: string;
  dept_name: string;
}

export interface Announce_Response_Type {
  message: string;
}

// ─── API Functions ────────────────────────────────────────────────────────────

export const announceContent = (payload: Announce_Payload_Type) =>
  generic_post_network_request<Announce_Response_Type, Announce_Payload_Type>(
    'announce',
    payload
  );
